<div class="page-width search-bar__inner-wrap">
  <form [formGroup]="searchForm" (ngSubmit)="onSubmit(searchForm.value)">
  <div class="field-button-combo search-bar__field-button-combo">
    <div class="field field-button-combo__field">
      <label for="student-keywords" class="label  is-vishidden ">Find a Student</label>
      <input class="input" formControlName="term" id="student-keywords" name="student-keywords" type="search" placeholder="Find a student">
    </div>
    <button class="button  field-button-combo__button" >Search</button>
  </div>
  </form>
</div>